import axios from 'axios'
import config from '../../config/local-config'
import apiConfig from '../../config/api-config'

const sendPolicyForm = data => {
  const version = 'v1'
  const serviceName = 'static/form/low-price-guarantee'
  const apiUrl = `${apiConfig.apiURL}/${version}/${serviceName}/`

  const body = {
    name: data.custName,
    email: data.custEmail,
    phoneNumber: data.custPhoneNumber,
    address: data.custShippingAddress,
    sku: data.partNumber,
    compName: data.compName,
    compSku: data.compSku,
    compPrice: data.compPrice,
    compShipping: data.compShipping,
    compUrl: data.compUrl,
    domain: config.hydra.site,
    'g-recaptcha-response': data.captcha,
    webToCase: 1,
  }

  const headers = {
    apikey: apiConfig.apiKey,
  }
  return (
    axios.post(
      apiUrl, body, { headers },
    ).then(response => response)
      .catch(err => { throw err })
  )
}
export default sendPolicyForm
